/* =====================================================
   DAR_CUSTOM: DarBeauty Custom JavaScript
   هذا الملف يحتوي جميع السكربتات المخصصة لـ DarBeauty
   عند تحديث الثيم: انسخ هذا الملف كاملاً بدون تعديل
   ===================================================== */
document.addEventListener('DOMContentLoaded', function () {
  /* ===== تنظيف روابط المنتجات من معلمات البحث ===== */
  if (window.location.pathname.includes('/products/')) {
    // التحقق مما إذا كان الرابط الحالي يحتوي على معلمات بحث
    if (window.location.search) {
      // إنشاء URLSearchParams للتعامل مع معلمات البحث
      var urlParams = new URLSearchParams(window.location.search);

      // التحقق من وجود ref=review
      var hasRefReview = urlParams.get('ref') === 'review';

      var cleanUrl;
      if (hasRefReview) {
        // الاحتفاظ فقط بـ ref=review
        cleanUrl = window.location.origin + window.location.pathname + '?ref=review';
      } else {
        // إنشاء الرابط النظيف (بدون معلمات البحث)
        cleanUrl = window.location.origin + window.location.pathname;
      }

      // استخدام history.replaceState لتغيير URL دون إعادة تحميل الصفحة
      history.replaceState({}, document.title, cleanUrl);
    }
  }

  /* ===== فتح الكيبورد عند الضغط على زر البحث ===== */
  var searchLink = document.querySelector('a[href="/search"]');
  var searchInput = document.querySelector('header-search .header-search__input');
  var searchDialog = document.querySelector('header-search[role="dialog"]');
  if (searchLink && searchInput && searchDialog) {
    searchLink.addEventListener('touchend', function (event) {
      event.preventDefault();
      if (!searchDialog.hasAttribute('open')) {
        searchDialog.setAttribute('open', '');
        searchDialog.style.display = 'block';
        // تجنب استدعاء offsetHeight للحد من إعادة التدفق
        setTimeout(function () {
          searchInput.focus();
        }, 10);
      } else {
        searchInput.focus();
      }
    });
  }

  /* ===== إخفاء زر "نفذ من المخزون" عندما يكون المنتج غير متوفر ===== */
  var soldOutButton = document.querySelector('.shopify-product-form .button[disabled]');
  if (soldOutButton) {
    soldOutButton.style.display = 'none';
  }

  /* ===== Footer responsive (updateFooterBlocks on resize/load) ===== */
  var _ftResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(_ftResizeTimer);
    _ftResizeTimer = setTimeout(function () { updateFooterBlocks(); }, 100);
  });
  setTimeout(function () { updateFooterBlocks(); }, 0);

  /* ===== DAR_CUSTOM: زر الإضافة السريعة (+) — تحميل صادق وكشف الفشل الصامت =====

     المشكلة الجذرية في الثيم نفسها (موجودة قبل أي تعديل):
     في assets/theme.js دالة onSubmit_fn لا تعالج فشل الإضافة إطلاقاً:

       1) ردّ غير ناجح مع JSON (نفد المخزون / تجاوز حد الطلبات):
          يُطلق حدث cart:error — لكن مستقبِله <buy-buttons> موجود في صفحة
          المنتج فقط ولا وجود له في كروت المنتجات. تحقّقنا: false.
          النتيجة: التحميل يبدأ وينتهي ولا تُضاف ولا تظهر أي رسالة.

       2) ردّ ليس JSON (رابط معاينة انتهى / بعد نشر ثيم جديد):
          السطر await response.json() يرمي استثناءً، فلا يُطلق theme:loading:end
          ولا أي حدث آخر — فشل صامت تام.

       3) انقطاع الشبكة (fetch يُرفَض):
          السطر الذي يُزيل aria-busy لا يُنفَّذ أبداً، فيبقى aria-busy="true"
          على الزر للأبد. وبداية onSubmit_fn تتحقق من aria-busy وتخرج فوراً،
          فتُتجاهل كل ضغطة تالية على ذلك الزر بصمت حتى تحديث الصفحة.
          أثبتناه عملياً: الضغط بشبكة سليمة بعدها لم يُطلق ولا حدث واحد.

     لذلك كان الزائر يرى تحميلاً "وهمياً": تظهر الدائرة لأن النقرة وصلت للزر
     فعلاً، ثم تنتهي، بينما الإضافة لم تحدث ولا رسالة تظهر — وفي الحالة 3 يبقى
     الزر ميتاً تماماً حتى تحديث الصفحة.

     الحل هنا يعتمد على أحداث الثيم نفسها فقط — بلا تعديل theme.js وبلا
     اعتراض window.fetch وبلا أي طلب إضافي في المسار الناجح. */

  /* لا نعتمد على theme:loading:end (يُطلق على documentElement فلا يدل على أي زر)
     ولا على unhandledrejection (أثبت الاختبار أنه لا يُطلق إطلاقاً هنا).
     الإشارات المضمونة الوحيدة تُطلق على النموذج نفسه: variant:add للنجاح
     و cart:error للفشل — ومنهما نعرف الزر بدقة. وما عدا ذلك = طلب ميت. */
  var DAR_STALE_MS = 4000;   // طلب لم يرد خلال هذه المدة يُعتبر ميتاً
  var _attempts = new Map(); // زر -> محاولة إضافة (يدعم أكثر من زر في وقت واحد)
  var _lastCartCount = null; // آخر عدد معروف للسلة (من أحداث الثيم، بلا طلبات)

  function darIsArabic() {
    return (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;
  }

  function darCartErrorText() {
    return darIsArabic()
      ? 'تعذّر إضافة المنتج إلى السلة. الرجاء المحاولة مرة أخرى.'
      : 'Could not add the product to your cart. Please try again.';
  }

  // رسالة بنفس أسلوب الثيم (banner banner--error) في حاوية ثابتة، لأن مستقبِل
  // cart:error الأصلي <buy-buttons> غير موجود في كروت المنتجات
  function darShowCartError(message) {
    var host = document.getElementById('dar-cart-error');
    if (!host) {
      host = document.createElement('div');
      host.id = 'dar-cart-error';
      document.body.appendChild(host);
    }
    host.innerHTML = '';
    var banner = document.createElement('div');
    banner.className = 'banner banner--error';
    banner.setAttribute('role', 'alert');
    banner.setAttribute('aria-live', 'polite');
    banner.textContent = message;
    host.appendChild(banner);
    clearTimeout(host.darTimer);
    host.darTimer = setTimeout(function () { host.innerHTML = ''; }, 5000);
  }

  // يحرّر الزر من aria-busy الذي يتركه theme.js عالقاً عند فشل الطلب.
  // بدون هذا يخرج onSubmit_fn فوراً في كل ضغطة تالية ويبقى الزر ميتاً حتى
  // تحديث الصفحة — وهذا هو سبب "التحميل الوهمي".
  function darReleaseButton(btn) {
    if (btn && btn.getAttribute('aria-busy') === 'true') btn.removeAttribute('aria-busy');
  }

  function darStopSpinner(att) {
    att.btn.classList.remove('is-loading');
    // على الكمبيوتر تُبقي قاعدة :focus في theme.css الزر ظاهراً ما دام مركّزاً،
    // فنُزيل التركيز بعد انتهاء الطلب فقط (لا أثناء النقرة) حتى لا نلمس إرسال
    // النموذج، وللماوس/اللمس فقط لا لوحة المفاتيح — حفاظاً على الوصولية.
    if (att.byPointer && document.activeElement === att.btn) {
      try { att.btn.blur(); } catch (err) {}
    }
  }

  function darCloseAttempt(att) {
    clearTimeout(att.staleTimer);
    _attempts.delete(att.btn);
    darStopSpinner(att);
  }

  // الزر الذي أطلق حدثاً على نموذجه
  function darButtonOfEvent(e) {
    var form = e.target && e.target.closest ? e.target.closest('form') : null;
    if (!form) return null;
    return form.querySelector('.product-card__quick-add-button');
  }

  // السلة هي مصدر الحقيقة: لا رسالة فشل إلا إذا لم يزد عدد العناصر فعلاً.
  // يمنع الإنذار الكاذب حين تنجح الإضافة ويُفقد حدثها (مثلاً يفشل جلب cart.js
  // في theme.js بعد إضافة ناجحة فلا يُطلق variant:add أبداً).
  function darVerifyThenWarn(att) {
    var baseline = _lastCartCount;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        if (count !== null) _lastCartCount = count;
        if (baseline !== null && count !== null && count > baseline) return; // نجحت فعلاً
        darShowCartError(darCartErrorText());
      })
      .catch(function () { darShowCartError(darCartErrorText()); });
  }

  // نقرة زر + في بطاقة منتج
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-card__quick-add-button');
    if (!btn) return;

    // زر submit فقط (منتج بخيار واحد). متعدد الخيارات يفتح نافذة الخيارات
    // ولا يوجد طلب إضافة نُنتظره.
    if (btn.type !== 'submit') return;

    var prev = _attempts.get(btn);
    if (prev && Date.now() - prev.startedAt < DAR_STALE_MS) return; // طلب حقيقي جارٍ
    if (prev) darCloseAttempt(prev); // محاولة ميتة — ننظّفها

    // نحرّر aria-busy هنا تحديداً: هذا المعالج في مرحلة capture للنقرة وحدث
    // submit يأتي بعده، فيقرأ theme.js القيمة محرَّرة ويُكمل الإضافة طبيعياً.
    // ونفعله عند النقرة لا بمؤقّت، حتى لا نحرّر زراً لطلب بطيء ما زال حياً.
    darReleaseButton(btn);

    // أخفِ رسالة خطأ سابقة حتى لا تبقى معلّقة أثناء محاولة جديدة
    var errHost = document.getElementById('dar-cart-error');
    if (errHost && errHost.firstChild) {
      clearTimeout(errHost.darTimer);
      errHost.innerHTML = '';
    }

    btn.classList.add('is-loading');
    var att = {
      btn: btn,
      startedAt: Date.now(),
      byPointer: e.detail > 0, // 0 يعني تنشيط بلوحة المفاتيح
      staleTimer: null
    };
    att.staleTimer = setTimeout(function () {
      if (_attempts.get(btn) !== att) return;
      _attempts.delete(btn);
      darStopSpinner(att); // لا تحميل وهمي: نوقف الدائرة ثم نتأكد قبل أي رسالة
      darVerifyThenWarn(att);
    }, DAR_STALE_MS);
    _attempts.set(btn, att);
  }, true);

  // نجاح مؤكد
  document.addEventListener('variant:add', function (e) {
    var btn = darButtonOfEvent(e);
    var att = btn && _attempts.get(btn);
    if (att) darCloseAttempt(att);
  }, true);

  // فشل مؤكد برسالة شوبيفاي (نفد المخزون، تجاوز الحد المتاح، ...)
  document.addEventListener('cart:error', function (e) {
    var btn = darButtonOfEvent(e);
    var att = btn && _attempts.get(btn);
    if (!att) return;
    darCloseAttempt(att);
    darReleaseButton(btn);
    darShowCartError((e.detail && e.detail.error) || darCartErrorText());
  }, true);

  // نتابع عدد السلة من أحداث الثيم بلا أي طلب إضافي
  document.documentElement.addEventListener('cart:change', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && typeof cart.item_count === 'number') _lastCartCount = cart.item_count;
  });

  /* ===== DAR_CUSTOM: زر إتمام الشراء في درج السلة — حالة التحميل =====
     الزر submit داخل form يُحوِّل تحويلاً أصلياً، فيبدو جامداً حتى يبدأ التحويل
     (محسوس خاصة في الجوال). نضيف كلاساً للتعتيم وإظهار دائرة تحميل ومنع الضغط
     المتكرر. لا نستخدم disabled لأنه يُلغي إرسال النموذج ويمنع الدفع فعلياً. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    if (btn.classList.contains('dar-is-submitting')) return;

    btn.classList.add('dar-is-submitting');

    // شبكة أمان: إذا لم يبدأ التحويل (انقطاع شبكة أو إلغاء) أعد الزر لحالته
    setTimeout(function () { btn.classList.remove('dar-is-submitting'); }, 12000);
  }, true);

  // عند الرجوع من صفحة الدفع (زر الرجوع / bfcache) أعد الزر لحالته الطبيعية
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('button[name="checkout"].dar-is-submitting').forEach(function (b) {
      b.classList.remove('dar-is-submitting');
    });
  });
  /* ===== قوائم الفوتر القابلة للطي لأجهزة الجوال ===== */
  var footerBlocksProcessed = false;

  function updateFooterBlocks() {
    var isMobile = window.innerWidth <= 699;
    var footerBlocks = document.querySelectorAll('.footer__block');

    // تنفيذ التحويل فقط إذا كان الوضع مختلفًا عن الحالة السابقة
    if (isMobile && !footerBlocksProcessed) {
      footerBlocks.forEach(function (block) {
        var title = block.querySelector('.h6');
        if (title) {
          // تخزين المحتوى الأصلي لاستخدامه لاحقًا عند الحاجة
          if (!block.dataset.originalContent) {
            block.dataset.originalContent = block.innerHTML;
          }

          var content = title.nextElementSibling;
          var accordionDisclosure = document.createElement('accordion-disclosure');
          var details = document.createElement('details');
          var summary = document.createElement('summary');
          summary.innerHTML = title.textContent + '<span class="animated-plus"></span>';
          details.appendChild(summary);
          if (content) {
            details.appendChild(content.cloneNode(true));
          }
          accordionDisclosure.appendChild(details);

          // استخدام replaceChildren بدلاً من innerHTML للأداء الأفضل
          while (block.firstChild) {
            block.removeChild(block.firstChild);
          }
          block.appendChild(accordionDisclosure);
        }
      });
      footerBlocksProcessed = true;
    } else if (!isMobile && footerBlocksProcessed) {
      // إعادة المحتوى الأصلي عند العودة إلى وضع سطح المكتب
      footerBlocks.forEach(function (block) {
        if (block.dataset.originalContent) {
          block.innerHTML = block.dataset.originalContent;
        }
      });
      footerBlocksProcessed = false;
    }
  }
  /* ===== مغير اللغة والبلد الموحد ===== */
  (function () {
    var popup = document.getElementById('dar-locale-popup');
    if (!popup) return;

    var langToggle = document.getElementById('dar-lang-toggle');
    var countryList = document.getElementById('dar-country-list');
    var formLocale = document.getElementById('dar-form-locale');
    var formCountry = document.getElementById('dar-form-country');
    var applyBtn = document.getElementById('dar-locale-apply');
    var form = applyBtn ? applyBtn.closest('form') : null;
    var returnToInput = form ? form.querySelector('input[name="return_to"]') : null;

    // القيم الفعلية المؤكدة من السيرفر (مصدر الحقيقة)
    // الحقول المخفية تتغيّر بنقرات المستخدم، لذلك لا نعتمد عليها كمرجع
    var currentLang = popup.dataset.currentLocale || (formLocale ? formLocale.value : '');
    var currentCountry = popup.dataset.currentCountry || (formCountry ? formCountry.value : '');

    // القيم الأصلية عند فتح الـ popup (تُحدَّث عند كل فتح)
    var initialLang = currentLang;
    var initialCountry = currentCountry;

    // تحديث حالة زر التطبيق
    function updateApplyState() {
      if (!applyBtn || !formLocale || !formCountry) return;
      var hasChanged = formLocale.value !== initialLang
                    || formCountry.value !== initialCountry;
      applyBtn.disabled = !hasChanged;
      applyBtn.classList.toggle('is-disabled', !hasChanged);
    }

    function buildCheckSvg() {
      var checkSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      checkSvg.setAttribute('class', 'dar-country-list__check');
      checkSvg.setAttribute('width', '14');
      checkSvg.setAttribute('height', '14');
      checkSvg.setAttribute('viewBox', '0 0 16 16');
      checkSvg.setAttribute('fill', 'none');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M3 8.5L6.5 12L13 4');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.5');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      checkSvg.appendChild(path);
      return checkSvg;
    }

    // تحديد اللغة بصرياً وفي الحقل المخفي
    function selectLanguage(code) {
      if (!langToggle || !formLocale) return;
      langToggle.querySelectorAll('.dar-lang-toggle__btn').forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.langCode === code);
      });
      formLocale.value = code;
    }

    // تحديد البلد بصرياً وفي الحقل المخفي
    function selectCountry(code) {
      if (!countryList || !formCountry) return;
      formCountry.value = code;
      countryList.querySelectorAll('.dar-country-list__item').forEach(function (item) {
        var isSelected = item.dataset.countryCode === code;
        item.classList.toggle('is-selected', isSelected);
        var check = item.querySelector('.dar-country-list__check');
        if (isSelected && !check) {
          item.appendChild(buildCheckSvg());
        } else if (!isSelected && check) {
          check.remove();
        }
      });
    }

    // إعادة الـ popup لحالته الأصلية المطابقة للغة/بلد الموقع الفعلي
    function resetPopupState() {
      selectLanguage(currentLang);
      selectCountry(currentCountry);
      initialLang = currentLang;
      initialCountry = currentCountry;

      // مزامنة return_to مع الصفحة الحالية وقت الفتح
      if (returnToInput) {
        returnToInput.value = window.location.pathname + window.location.search;
      }

      // إعادة زر التطبيق لحالته الطبيعية (مهم عند استرجاع الصفحة من bfcache أثناء التحميل)
      if (applyBtn) {
        var textEl = applyBtn.querySelector('.dar-locale-popup__apply-text');
        var loaderEl = applyBtn.querySelector('.dar-locale-popup__apply-loader');
        if (textEl) textEl.style.display = '';
        if (loaderEl) loaderEl.hidden = true;
      }
      updateApplyState();
    }

    // مزامنة اللغة مع الحقل المخفي (أزرار أفقية)
    if (langToggle) {
      langToggle.addEventListener('click', function (e) {
        var btn = e.target.closest('.dar-lang-toggle__btn');
        if (!btn || btn.classList.contains('is-active')) return;
        selectLanguage(btn.dataset.langCode);
        updateApplyState();
      });
    }

    // معالجة اختيار البلد من القائمة (buttons with flags)
    if (countryList) {
      countryList.addEventListener('click', function (e) {
        var btn = e.target.closest('.dar-country-list__item');
        if (!btn || !btn.dataset.countryCode) return;
        selectCountry(btn.dataset.countryCode);
        updateApplyState();
      });
    }

    // فتح الـ popup
    document.querySelectorAll('[data-open-locale-popup]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // إعادة التعيين عند كل فتح — يمنع بقاء اختيارات غير مطبَّقة من مرة سابقة
        resetPopupState();

        // إذا كان الزر داخل السايدبار → أغلق السايدبار أولاً
        var sidebar = trigger.closest('header-sidebar');
        if (sidebar) {
          sidebar.removeAttribute('open');
          setTimeout(function () { popup.showModal(); }, 350);
        } else {
          popup.showModal();
        }
      });
    });

    // إغلاق الـ popup
    popup.querySelectorAll('[data-close-popup]').forEach(function (el) {
      el.addEventListener('click', function () {
        popup.close();
      });
    });

    // منع إغلاق عند الضغط على المحتوى
    var panel = popup.querySelector('.dar-locale-popup__panel');
    if (panel) {
      panel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    // عند استرجاع الصفحة من bfcache (بعد خمول طويل أو زر الرجوع):
    // أغلق الـ popup وأعد تهيئته حتى لا يبقى الزر معطلاً أو الحقول بلغة قديمة
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        if (popup.open) popup.close();
        resetPopupState();
      }
    });

    // حالة التحميل عند الإرسال
    if (applyBtn && form) {
      form.addEventListener('submit', function () {
        applyBtn.disabled = true;
        var textEl = applyBtn.querySelector('.dar-locale-popup__apply-text');
        var loaderEl = applyBtn.querySelector('.dar-locale-popup__apply-loader');
        if (textEl) textEl.style.display = 'none';
        if (loaderEl) loaderEl.hidden = false;
      });
    }
  })();
});